import React from 'react';
import ReactGA from 'react-ga';
import GIEContainer from '../../components/GIEContainer/GIEContainer';
import imgUrl from '../../assets/img/kitchen.jpg';
import TitleHomeCompoent from './TitleHome';
import CardHome from './CardHome';
import ResiliationdHome from './ResiliationHome';
import HomeController from '../../controller/home.controller';
import userInformations from '../../userInformation/user_informations';
import calendarIcon from '../../assets/icon/calendar-days.svg';
import euroIcon from '../../assets/icon/circle-euro.svg';
import fileIcon from '../../assets/icon/file-lines.svg';
import screwdriverWrenchIcon from '../../assets/icon/screwdriver-wrench.svg';
import WarningIcon from '@material-ui/icons/Warning';
import FolderIcon from '@material-ui/icons/Folder';
import GIESvgIcon from "../../components/GIEIcon/GIESvgIcon";

export default class Home extends React.Component<any, any> {
  homeController: HomeController = new HomeController();

  constructor(props) {
    super(props);
    this.state = {
      contractNumber: "",
      price: 0,
      rdv: '',
      outstanding: 0,
      isCollective: false,
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
    const noContract = userInformations.getNoContract();
    if (noContract == null || noContract.length === 0) {
      window.location.href = "/admin/login"
    } else {
      this.getData()
    }
  }

  getData = () => {
    this.homeController.getHomeInformations().then((data: any) => {
      this.manageData(data)
    }).catch(err => {
      console.log(err)
    })
  }

  manageData = data => {
    this.setState({
      contractNumber: data.contractNumber,
      isCollective: data.isCollective,
      outstanding: data.outstanding,
      price: data.price
    })
    data.rdv === "Aucune Intervention en cours " ? this.setState({rdv: 'Aucun rendez-vous planifié '}) : this.setState({rdv: data.rdv})
  }

  render() {
    return (
      <div className="content">
        <GIEContainer imgUrl={imgUrl} title={<TitleHomeCompoent/>}>
          <div className="container-xl">
            <div className="row g-4">
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Votre contrat d'entretien"
                          secondTitle={this.state.contractNumber || " "}
                          icon={<GIESvgIcon big icon={fileIcon}/>}
                          link="Consulter mes informations"
                          url="/admin/mes-informations"/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Votre prochain rendez-vous"
                          secondTitle={this.state.isCollective ? "Vous ne pouvez pas voir le prochain rendez-vous car vous avez un contrat collectif" : this.state.rdv || " "}
                          icon={<GIESvgIcon big icon={calendarIcon}/>}
                          link="Modifier mon rendez-vous" url="/admin/rendez-vous"
                          hideLink={this.state.isCollective || this.state.rdv === "Aucun entretien planifié"}/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Votre solde"
                          secondTitle={Number(this.state.outstanding) > 0 ? '' + this.state.outstanding + '€ à payer ' : '' + this.state.outstanding + '€ '}
                          icon={<GIESvgIcon icon={euroIcon} big/>}
                          link="Consulter votre relevé de situation"
                          url="/admin/en-cours"/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Signaler une panne"
                          icon={<WarningIcon className="big"/>}
                          url="/admin/formulaire-d-urgence"
                          hideLink/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Installer ou remplacer un équipement"
                          icon={<GIESvgIcon icon={screwdriverWrenchIcon} big/>}
                          url="/admin/equipement"
                          hideLink/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="Mes documents"
                          icon={<FolderIcon className="big"/>}
                          url="/admin/documents"
                          hideLink/>
              </div>
            </div>
          </div>
          <div className="my-3">
            <ResiliationdHome/>
          </div>
        </GIEContainer>
      </div>);
  }
}
